import React from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm, getFormValues} from 'redux-form';
import moment from 'moment';
import {Divider, Subheader, CardTitle,
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardActions,
  Button,
  LinearProgress
} from 'react-md';

import FormView from '../../../../../components/entity/form.view';
// import NomorBPService from '../nomorBP.service';
import {validation, Textfield, Searchfield, TextfieldMask, Switch, Datepicker, Checkbox, Radio} from '../../../../../components/form';
import UtilService from '../../../../../services/utils.service'
import terbilangService from '../../../../../services/terbilang.service';
import Master4a2KapService from '../../4a2/master/Kap/Master4a2Kap.service';
import Master4a2KjsService from '../../4a2/master/Kjs/Master4a2Kjs.service';
import PBK4a2Service from './PBK4a2.service';
import BlokBunifikasiService from 'app:modules/Main/pph/21_26/BlokBunifikasi/BlokBunifikasi.service';


@reduxForm({form: 'PBK4a2_Form', destroyOnUnmount: true, initialValues: {}})
@connect((state) => ({
  access      : state.entity.access.api.find,
  organization: state.authEppt.currentOrganization,
  spt         : state.authEppt.currentSPT,
  formData    :getFormValues('PBK4a2_Form')(state),
  auth        : state.auth.company,
}))
export default class PBK4a2Form extends FormView {
  service=PBK4a2Service
  viewType =2;

  masaOptions = [
    {id:1, name: 1}, {id:2, name: 2}, {id:3, name: 3}, {id:4, name: 4}, {id:5, name: 5}, {id:6, name: 6},
    {id:7, name: 7}, {id:8, name: 8}, {id:9, name: 9}, {id:10, name: 10}, {id:11, name: 11}, {id:12, name: 12}
  ]

  initialData={
    bagA: {},
    bagB: {bruto: 0},
    bagC: {}
  }

  async beforeSave(value){
    // EPPT CORE
    var mapping = {
      froms: {
        address         : value.dari.alamat,
        anotherType     : value.dari.jenisLain,
        depositType     : value.dari.jenisSetoran,
        depositTypeCode : value.dari.kodeJenisSetoran,
        mapCode         : value.dari.kodeMap,
        month           : value.dari.masa,
        name            : value.dari.nama,
        no              : value.dari.nomor,
        npwp            : value.dari.npwp,
        otherTypeNumber : value.dari.nomorJenisLain,
        taxType         : value.dari.jenisPajak,
        year            : parseInt(value.dari.tahun)
      },
      tos: {
        address           : value.kepada.alamat,
        anotherType       : value.kepada.jenisLain,
        depositType       : value.kepada.jenisSetoran,
        depositTypeCode   : value.kepada.kodeJenisSetoran,
        mapCode           : value.kepada.kodeMap,
        month             : value.kepada.masa,
        name              : value.kepada.nama,
        no                : value.kepada.nomor,
        npwp              : value.kepada.npwp,
        otherTypeNumber   : value.kepada.nomorJenisLain,
        taxType           : value.kepada.jenisPajak,
        year              : parseInt(value.kepada.tahun)
      },
      beCalculated  : value.terbilang,
      category      : value.kategori,
      categoryDate  : value.tanggalKategori,
      categoryNo    : value.nomorKategori,
      dateOf        : value.tanggalPembuatan,
      effectiveDate : value.tanggalBerlaku,
      name          : value.namaPejabat,
      nip           : value.nipPejabat,
      no            : value.nomor,
      place         : value.tempat,
      spt           : value.spt,
      total         : value.jumlahPbk,
    }
    if(value.id && value.id != "new") mapping.id = value.id
    value = mapping
    // EPPT CORE

    value.blockBunifikasiMonth = 4;
    value.blockBunifikasiYear = 2022;
    try {
      let res = await BlokBunifikasiService.api.getSettingAccess(this.props.match.params.companyId)
      if(res.data.active){
        value.blockBunifikasiMonth = res.data.bulan
        value.blockBunifikasiYear = res.data.tahun
      }
    } catch(e) {}

    return value;
  }

  async initData() {
    if(this.props.match.params.id == 'new') {
      // EPPT CORE
      // var org = this.props.spt.data.organization;
      // var initialData={
      //   spt: this.props.spt.data,
      //   kepada: {
      //     nama:org.name,
      //     npwp: org.npwp,
      //     alamat: org.address
      //   },
      //   useDefault: true,
      //   useCustom: false
      // }
      var org = this.props.spt.data;
      var initialData={
        spt: this.props.spt.data,
        kepada: {
          nama: org.name,
          npwp: org.npwp,
          alamat: org.address
        },
        useDefault: true,
        useCustom: false
      }
      // EPPT CORE
      this.props.initialize(initialData);
    } else {
      let res = await this.service.api.findOne(this.props.match.params.id);


      if(res.data.kategori == 'Permohonan WP' || res.data.kategori == 'SKKPP/SKPLB' || res.data.kategori == 'Perhitungan Lebih Bayar Karena Keputusan Keberatan / Banding' || res.data.kategori == '') {
        res.data.useDefault = true;
        res.data.useCustom = false;
      } else {
        res.data.useDefault = false;
        res.data.useCustom = true;
      }

      if (res.data.tos === null) {
        res.data.tos = {}
      }

      // EPPT CORE
      var remapping = {
        useDefault: res.data.useDefault,
        useCustom : res.data.useCustom,
        id: res.data.id,
        dari: {
          alamat           : res.data.froms.address,
          jenisLain        : res.data.froms.anotherType,
          jenisSetoran     : res.data.froms.depositType,
          kodeJenisSetoran : res.data.froms.depositTypeCode,
          kodeMap          : res.data.froms.mapCode,
          masa             : res.data.froms.month,
          nama             : res.data.froms.name,
          nomor            : res.data.froms.no,
          npwp             : res.data.froms.npwp,
          nomorJenisLain   : res.data.froms.otherTypeNumber,
          jenisPajak       : res.data.froms.taxType,
          tahun            : parseInt(res.data.froms.year)
        },
        kepada: {
          alamat           : res.data.tos.address,
          jenisLain        : res.data.tos.anotherType,
          jenisSetoran     : res.data.tos.depositType,
          kodeJenisSetoran : res.data.tos.depositTypeCode,
          kodeMap          : res.data.tos.mapCode,
          masa             : res.data.tos.month,
          nama             : res.data.tos.name,
          nomor            : res.data.tos.no,
          npwp             : res.data.tos.npwp,
          nomorJenisLain   : res.data.tos.otherTypeNumber,
          jenisPajak       : res.data.tos.taxType,
          tahun            : parseInt(res.data.tos.year)
        },
        terbilang       : res.data.beCalculated,
        kategori        : res.data.category,
        tanggalKategori : res.data.categoryDate,
        nomorKategori   : res.data.categoryNo,
        tanggalPembuatan: res.data.dateOf,
        tanggalBerlaku  : res.data.effectiveDate,
        namaPejabat     : res.data.name,
        nipPejabat      : res.data.nip,
        nomor           : res.data.no,
        tempat          : res.data.place,
        spt             : res.data.spt,
        jumlahPbk       : res.data.total,
      }
      res.data = remapping
      // EPPT CORE

      this.props.initialize(res.data);
    }
  }

  async terbilang(e, v, pv) {
    await this.props.change('terbilang', terbilangService(parseInt(v)));
  }

  formView() {
    return (
      <div>
        <Card>
          <div className="md-grid">
            <Field
              label='Nomor PBK'
              name='nomor'
              style={{marginLeft:  54}}
              className="md-cell md-cell--12"
              component={Textfield}
              validate={validation.required}
            />
            <div className="mpk-layout md-grid md-cell--12" style={{padding:1}}>
              <Field
                style={{marginTop: 24, paddingLeft:0}}
                name='useDefault'
                component={Checkbox}

                onChange={(e,v) => this.props.change('useCustom', !v)}
              />
              <Field
                label='Kategori PBK'
                name='kategori'
                className="flex"
                component={Searchfield}
                disabled={!this.props.formData.useDefault}
                options={[
                  {id: 'Permohonan WP', name: 'Permohonan WP'},
                  {id: 'SKKPP/SKPLB', name: 'SKKPP/SKPLB'},
                  {id: 'Perhitungan Lebih Bayar Karena Keputusan Keberatan / Banding', name: 'Perhitungan Lebih Bayar Karena Keputusan Keberatan / Banding'}
                ]}
              />
            </div>
            <div className="mpk-layout md-grid md-cell--12" style={{padding:1}}>
              <Field
                style={{marginTop: 24, paddingLeft:0}}
                name='useCustom'
                component={Checkbox}
                onChange={(e,v) => this.props.change('useDefault', !v)}
              />
              {!this.props.formData.useCustom &&
                <Field
                  label='Kategori PBK Lain'
                  name='kategoriLain'
                  disabled
                  className="flex"
                  component={Textfield}
                />
              }
              {this.props.formData.useCustom &&
                <Field
                  label='Kategori PBK Lain'
                  name='kategori'
                  className="flex"
                  component={Textfield}
                />
              }

            </div>

            <Field
              label='Nomor'
              name='nomorKategori'
              style={{marginLeft:  54}}
              className="md-cell md-cell--12"
              component={Textfield}
            />
            <Field
              label='Tanggal'
              name='tanggalKategori'
              className="md-cell md-cell--12"
              component={Datepicker}
            />
          </div>
        </Card>

        <br/>

        <Card>
          <CardTitle title='' style={{padding: '10px 16px'}} subtitle='Dari' />
          <Divider/>
          <div className="md-grid">
            <Field
              label='Nama'
              name='dari.nama'
              className="md-cell md-cell--12"
              component={Textfield}
              />
            <Field
              label='Npwp'
              name='dari.npwp'
              className="md-cell md-cell--12"
              component={TextfieldMask}
              maskFormat="##.###.###.#-###-###"
              mask="_"
              length="15"
              />
            <Field
              label='Alamat'
              name='dari.alamat'
              className="md-cell md-cell--12"
              component={Textfield}
              />

            <Field
              label='Jenis Pajak'
              name='dari.jenisPajak'
              className="md-cell md-cell--12"
              component={Textfield}
              />

            <Field
              label='Masa'
              name='dari.masa'
              className="md-cell md-cell--6"
              component={Searchfield}
              options={this.masaOptions}
              />
            <Field
              label='Tahun'
              name='dari.tahun'
              className="md-cell md-cell--6"
              component={Textfield}
              />

            <Field
              label='Kode Map'
              name='dari.kodeMap'
              className="md-cell md-cell--6"
              component={Searchfield}
              validate={validation.required}
              viewField="nama"
              valueField="nama"
              options={[{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da58","nama":"411121(0111)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5a","nama":"411122(0112)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5c","nama":"411123(0113)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5e","nama":"411124(0114)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da60","nama":"411125(0115)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da62","nama":"411126(0116)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da64","nama":"411127(0117)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da66","nama":"411128(0118)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da68","nama":"411129(0119)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6a","nama":"411111(0121)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6c","nama":"411112(0122)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6e","nama":"411113(0128)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da70","nama":"411611(0171)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da72","nama":"411619(0172)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da74","nama":"411621(0173)"}]}
              />
            <Field
              label='Kode Jenis Setoran'
              name='dari.kodeJenisSetoran'
              className="md-cell md-cell--6"

              component={TextfieldMask}
              maskFormat="###"
              maxLength={3}
              mask="_"
              // component={Searchfield}
              // service={Master23KjsService}
              // validate={validation.required}

              viewField="code"
              valueField="code"
              itemTemplate={function(d) {
                return {
                  primaryText: d.code,
                  secondaryText: d.name,
                  onClick: () => {
                    if(!this.props.disabled){
                      this.handleItemClick(d); this.hide()
                    }
                  }
                }
              }}
            />

            <Field
              label='Kode Jenis PBK'
              name='dari.jenisSetoran'
              className="md-cell md-cell--6"
              component={Searchfield}
              options={[
                {id: 'STP', name: 'STP'},
                {id: 'SKP', name: 'SKP'},
                {id: 'SKPT', name: 'SKPT'},
                {id: 'SKPLB', name: 'SKPLB'}
              ]}
            />
            <Field
              label='Nomor'
              name='dari.nomor'
              className="md-cell md-cell--6"
              component={Textfield}
              />

            <Field
              label='Jenis Lain'
              name='dari.jenisLain'
              className="md-cell md-cell--6"
              component={Textfield}
              />
            <Field
              label='Nomor Jenis Lain'
              name='dari.nomorJenisLain'
              className="md-cell md-cell--6"
              component={Textfield}
              />
          </div>
        </Card>

        <br/>

        <Card>
          <CardTitle title='' style={{padding: '10px 16px'}} subtitle='Kepada' />
          <Divider/>
          <div className="md-grid">
            <Field
              label='Nama'
              name='kepada.nama'
              className="md-cell md-cell--12"
              component={Textfield}
              disabled
              />
            <Field
              label='Npwp'
              name='kepada.npwp'
              className="md-cell md-cell--12"
              component={TextfieldMask}
              maskFormat="##.###.###.#-###-###"
              mask="_"
              length="15"
              disabled
              />
            <Field
              label='Alamat'
              name='kepada.alamat'
              className="md-cell md-cell--12"
              component={Textfield}
              disabled
              />

            <Field
              label='Jenis Pajak'
              name='kepada.jenisPajak'
              className="md-cell md-cell--12"
              component={Textfield}
              />

            <Field
              label='Masa'
              name='kepada.masa'
              className="md-cell md-cell--6"
              component={Searchfield}
              options={this.masaOptions}
              />
            <Field
              label='Tahun'
              name='kepada.tahun'
              className="md-cell md-cell--6"
              component={Textfield}
              />

            <Field
              label='Kode Map'
              name='kepada.kodeMap'
              className="md-cell md-cell--6"
              component={Searchfield}
              validate={validation.required}
              viewField="nama"
              valueField="nama"
              options={[{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da58","nama":"411121(0111)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5a","nama":"411122(0112)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5c","nama":"411123(0113)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da5e","nama":"411124(0114)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da60","nama":"411125(0115)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da62","nama":"411126(0116)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da64","nama":"411127(0117)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da66","nama":"411128(0118)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da68","nama":"411129(0119)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6a","nama":"411111(0121)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6c","nama":"411112(0122)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da6e","nama":"411113(0128)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da70","nama":"411611(0171)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da72","nama":"411619(0172)"},{"createdBy":"system","createdDate":"2017-07-28T09:29:43Z","lastModifiedBy":null,"lastModifiedDate":"2018-06-04T07:49:58Z","id":"597b040793248e7fa710da74","nama":"411621(0173)"}]}
              />
            <Field
              label='Kode Jenis Setoran'
              name='kepada.kodeJenisSetoran'
              className="md-cell md-cell--6"

              component={TextfieldMask}
              maskFormat="###"
              maxLength={3}
              mask="_"
              // component={Searchfield}
              // service={Master23KjsService}
              // validate={validation.required}

              viewField="code"
              valueField="code"
              itemTemplate={function(d) {
                return {
                  primaryText: d.code,
                  secondaryText: d.name,
                  onClick: () => {
                    if(!this.props.disabled){
                      this.handleItemClick(d); this.hide()
                    }
                  }
                }
              }}
            />
            <Field
              label='Kode Jenis PBK'
              name='kepada.jenisSetoran'
              className="md-cell md-cell--6"
              component={Searchfield}
              options={[
                {id: 'STP', name: 'STP'},
                {id: 'SKP', name: 'SKP'},
                {id: 'SKPT', name: 'SKPT'},
                {id: 'SKPLB', name: 'SKPLB'}
              ]}
            />
            <Field
              label='Nomor'
              name='kepada.nomor'
              className="md-cell md-cell--6"
              component={Textfield}
              />

            <Field
              label='Jenis Lain'
              name='kepada.jenisLain'
              className="md-cell md-cell--6"
              component={Textfield}
              />
            <Field
              label='Nomor Jenis Lain'
              name='kepada.nomorJenisLain'
              className="md-cell md-cell--6"
              component={Textfield}
              />
          </div>
        </Card>

        <br/>

        <Card>
          <CardTitle title='' style={{padding: '10px 16px'}} subtitle='Detail' />
          <Divider/>
          <div className="md-grid">
            <Field
              label='Tanggal Berlaku'
              name='tanggalBerlaku'
              className="md-cell md-cell--12"
              component={Datepicker}
            />
            <Field
              label='Jumlah Pemindahbukuan'
              name='jumlahPbk'
              className="md-cell md-cell--12"
              money={','}
              component={TextfieldMask}
              onChange={(e,v,pv) => this.terbilang(e,v,pv)}
              />
            <Field
              label='Terbilang'
              name='terbilang'
              className="md-cell md-cell--12"
              component={Textfield}
              disabled
              />

            <Field
              label='Tempat'
              name='tempat'
              className="md-cell md-cell--6"
              component={Textfield}
              />
            <Field
              label='Tanggal Pemindahbukuan'
              name='tanggalPembuatan'
              className="md-cell md-cell--6"
              component={Datepicker}
            />
          </div>
        </Card>

        <br/>
        <Card>
          <CardTitle title='' style={{padding: '10px 16px'}} subtitle='Detail' />
          <Divider/>
          <div className="md-grid">
            <Field
              label='Nama Pejabat KPP'
              name='namaPejabat'
              className="md-cell md-cell--6"
              component={Textfield}
              />
            <Field
              label='Nip Pejabat KPP'
              name='nipPejabat'
              className="md-cell md-cell--6"
              component={Textfield}
              />
          </div>
        </Card>

      </div>
    )
  }

}
